import { render, staticRenderFns } from "./ModalLinkPageAccessGroup.vue?vue&type=template&id=5edbe856"
import script from "./ModalLinkPageAccessGroup.vue?vue&type=script&lang=js"
export * from "./ModalLinkPageAccessGroup.vue?vue&type=script&lang=js"
import style0 from "./ModalLinkPageAccessGroup.vue?vue&type=style&index=0&id=5edbe856&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edbe856')) {
      api.createRecord('5edbe856', component.options)
    } else {
      api.reload('5edbe856', component.options)
    }
    module.hot.accept("./ModalLinkPageAccessGroup.vue?vue&type=template&id=5edbe856", function () {
      api.rerender('5edbe856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalLinkPageAccessGroup.vue"
export default component.exports